import { FunctionComponent } from 'react';
import HeroKpiScoreboard from './HeroKpiScoreboard';
import AnatomiaModelo from './AnatomiaModelo';
import PlataformaViva from './PlataformaViva';

const Bloque1Penetracion: FunctionComponent = () => {
  return (
    <section className='estadisticas-gd-bloque'>
      <header className='estadisticas-gd-bloque-header'>
        <h3 className='estadisticas-gd-bloque-titulo'>
          1. Penetración de VisiónDERRED en la industria
        </h3>
        <small className='vdr-stats-bloque-tag' aria-hidden='true'>
          Adopción
        </small>
        <p className='estadisticas-gd-bloque-subtitulo'>
          El sistema de distribución de Chile, modelado en una sola plataforma.
        </p>
      </header>

      <div className='bloque1-subbloque'>
        <h4 className='bloque1-subbloque-titulo'>1.A · Indicadores de Adopción</h4>
        <HeroKpiScoreboard />
      </div>

      <hr className='estadisticas-gd-divider' />

      <div className='bloque1-subbloque'>
        <h4 className='bloque1-subbloque-titulo'>1.B · Infraestructura modelada</h4>
        <p className='bloque1-subbloque-descripcion'>
          Indicadores técnicos de los modelos eléctricos.
        </p>
        <AnatomiaModelo />
      </div>

      <hr className='estadisticas-gd-divider' />

      <div className='bloque1-subbloque'>
        <h4 className='bloque1-subbloque-titulo'>1.C · Uso de la plataforma</h4>
        <p className='bloque1-subbloque-descripcion'>
          La plataforma se usa todos los meses para validar nuevos desarrollos.
        </p>
        <PlataformaViva />
      </div>
    </section>
  );
};

export default Bloque1Penetracion;
